import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';

export enum SubtotalAmountDataHook {
  SubtotalAmountRoot = 'SubtotalAmount.root',
  SubtotalAmountValue = 'TotalAmount.subtotalText',
}

export interface SubtotalAmountProps {
  subtotalAmount: string;
}

export const SubtotalAmount = ({subtotalAmount}: SubtotalAmountProps) => {
  const {t} = useTranslation();

  return (
    <dl data-hook={SubtotalAmountDataHook.SubtotalAmountRoot}>
      <dt>{t('sideCart.subtotal.label')}</dt>
      <dd data-hook={SubtotalAmountDataHook.SubtotalAmountValue} data-wix-sub-totals-value>
        {subtotalAmount}
      </dd>
    </dl>
  );
};
